import IconDownload from 'components/Varios/IconDownload';
import React from 'react'

//BOOTSTRAP
import { Row, Col, Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import { propsCardInfoConvenios } from './TypesContratoBecas';

const CardInfoContratosBecas = (props: propsCardInfoConvenios) => {

    const { datosCards, indice, total } = props;
    return (

        <Card className="cardInfoConvenios">

            <CardBody className=" card-body cardBodyInfoConvenios">

                <div> <span className='spanCard'>FECHA FIRMA CONTRATO:</span> {datosCards.fechaFirmaContrato}</div>
                <div> <span className='spanCard'> NRO CONTRATO: </span>{datosCards.nroContrato}</div>
                <div>  <span className='spanCard' > TIPO : </span> CONTRATO {datosCards.tipoContrato === "CONTRATO" ? "ORIGINAL" : datosCards.tipoContrato}   </div>
                {datosCards.monto && datosCards.tipoMoneda &&
                    <div> <span className='spanCard'> MONTO: </span>  {datosCards.monto} {datosCards.tipoMoneda}</div>

                }
                <div> <span className='spanCard'> FECHA INICIO ESTUDIO: </span> {datosCards.fechaInicioEstudio}</div>
                <div> <span className='spanCard'> FECHA FIN ESTUDIO: </span> {datosCards.fechaFinEstudio}</div>
                <div> <span className='spanCard'> TIPO ESTUDIO: </span>  {datosCards.tipoEstudio}</div>
                <div> <span className='spanCard'> PAÍS: </span>  {datosCards.pais}</div>
                <div> <span className='spanCard'> INSTITUCIÓN IES: </span>  {datosCards.institucionIES}</div>
                <div> <span className='spanCard'> TITULO OBTENER: </span>  {datosCards.tituloObtener}</div>
                <div> <span className='spanCard'> ESTADO: </span>  {datosCards.estado}</div>
            </CardBody>
            <CardFooter className="text-muted">
                <div style={{ float: "left" }}>
                    {indice}/{total}

                </div>
            </CardFooter>
        </Card>

    )
}

export default CardInfoContratosBecas